<template>
	<section class="franchaise_mob container-wrap">
		<div class="container-box">
			<div class="row">
				<h2 class="franchaise_title">
					JP WORLD PAY
					{{ $t('new_ui.franchaise_page.section_banner.title.one') }}
					{{ $t('new_ui.franchaise_page.section_banner.title.two') }}
				</h2>
				<div class="col-sm-12">
					<div class="custom-select-wrapper">
						<select
							id="franchise_item"
							class="custom-select"
							v-model="selectedSectionIndex"
							@focus="isSectionSelectFocused = true"
							@blur="isSectionSelectFocused = false"
						>
							<option disabled hidden :value="null">Select Section</option>
							<option
								v-for="option in sectionOptions"
								:key="option.value"
								:value="option.value"
							>
								{{ option.label }}
							</option>
						</select>
						<i
							class="fa fa-chevron-down select-chevron"
							:class="{ rotated: isSectionSelectFocused }"
						></i>
					</div>

					<div class="custom-select-wrapper">
						<select
							id="franchise_item_inner"
							class="custom-select"
							v-model="selectedItemKey"
							@focus="isSectionSelectFocused = true"
							@blur="isSectionSelectFocused = false"
						>
							<option disabled hidden :value="null">Select Item</option>
							<option
								v-for="option in itemOptions"
								:key="option.value"
								:value="option.value"
							>
								{{ option.label }}
							</option>
						</select>
						<i
							class="fa fa-chevron-down select-chevron"
							:class="{ rotated: isSectionSelectFocused }"
						></i>
					</div>

					<component
						v-if="selectedSectionIndex !== null && selectedItemKey"
						:is="
							sidebarMenus[selectedSectionIndex]?.items.find(
								item => item.key === selectedItemKey,
							)?.component
						"
					/>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import franchaise from '@/assets/images/sub/franchaise_ban.png';
import line_arow from '@/assets/images/sub/line_arow.png';
import { SIDEBAR_MENUS_TERMS } from '@/common/constants.js';
export default {
	name: 'TermsMobile',
	data() {
		return {
			img: {
				image1: franchaise,
				image2: line_arow,
			},
			selectedSectionIndex: null,
			isSectionSelectFocused: false,
			sidebarMenus: SIDEBAR_MENUS_TERMS,

			selectedItemKey: null, // default to first item key of selected section
		};
	},
	computed: {
		sectionOptions() {
			return this.sidebarMenus.map((menu, idx) => ({
				label: menu.section,
				value: idx,
			}));
		},
		itemOptions() {
			const items = this.sidebarMenus[this.selectedSectionIndex]?.items || [];
			return items.map(item => ({
				label: item.label,
				value: item.key,
			}));
		},
	},
	watch: {
		selectedSectionIndex() {
			// Reset item selection when section changes
			// const firstItem = this.sidebarMenus[newIdx]?.items[0];
			// this.selectedItemKey = firstItem ? firstItem.key : '';
			this.selectedItemKey = null;
		},
	},
	mounted() {
		// Set default selected item on mount
		// const firstItem = this.sidebarMenus[0]?.items[0];
		// this.selectedItemKey = firstItem ? firstItem.key : '';
		this.selectedItemKey = null;
	},
};
</script>
